import { SearchFilterTable } from '@/components/search/search';

export type SearchFilterProps = {
  readonly defaultValue?: string;
  readonly onChange: (value: string) => void;
};

export function SearchFilter({ defaultValue = '', onChange }: SearchFilterProps) {
  const placeholder = 'Search by name, technology, country...';
  return <SearchFilterTable globalFilter={defaultValue} setGlobalFilter={onChange} placeholder={placeholder} />;
}
